import React, { useState, useEffect, useContext } from "react";
import { PopoverPicker } from "./PopoverPicker";
import "./styles.css";
import MainContext from "../../../../context/mainContext";

export default function Slecetor({ handleSetColor, type, level, styleType }) {
  const { subWordLearningStyles, subWordCEFRStyles } = useContext(MainContext);

  const setColors = (value) => {
    handleSetColor(type, level, value)
  }

  return <PopoverPicker color={styleType == "cefr" ? subWordCEFRStyles[`${type}_${level}`] : subWordLearningStyles[`${type}_${level}`]} onChange={setColors} />;
};
